import Controller from '@ember/controller';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';

import {
  ContractSignPolling,
  PendingContract,
} from '@repo/customer-registration-kit/contract-sign';
import { dropTask } from 'ember-concurrency';
import window from 'ember-window-mock';

import { embedOnboardingURL, jsURL } from 'register-partners-js/constants/hosts';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { fetchNavigationOrganizationsClient } from 'register-partners-js/utils/fetch-navigation-organizations';
import { shouldRedirectToEmbed } from 'register-partners-js/utils/should-redirect-to-embed';

import styles from './styles.module.css';

const CONTRACT_SIGNED_STATUSES = ['completed', 'contract_signed'];

export default class RegistrationPendingContractController extends Controller {
  mainLayout = MainLayout;
  pendingContract = PendingContract;
  contractSignPolling = ContractSignPolling;
  styles = styles;

  @service apiFlowManager;
  @service deviceManager;
  @service intl;
  @service router;

  handlePollTask = dropTask(
    waitFor(async () => {
      let registration = this.model;
      await registration.reload();

      if (CONTRACT_SIGNED_STATUSES.includes(registration.status)) {
        if (this.apiFlowManager.isPartnersService) {
          await this.#handleRedirectPartnerApi(registration);
        } else {
          await this.#handleRedirectRegisterApi(registration);
        }
      }
    })
  );

  async #handleRedirectRegisterApi(registration) {
    let organization = await registration.get('organization');

    if (registration.isFastTrackWithoutCapitalDeposit) {
      let organizations = await fetchNavigationOrganizationsClient();
      let appOrganization = organizations.find(o => o.id === organization.id);
      if (!appOrganization) return;
      window.location.href = `${jsURL}/organizations/${appOrganization.slug}`;
    } else if (registration.isMicroEnterpriseCreationThoughLegalPlace) {
      await this.router.transitionTo('registration.credentials-success');
    } else if (shouldRedirectToEmbed(registration, organization)) {
      window.location.href = `${embedOnboardingURL}/${registration.id}`;
    } else {
      await this.router.transitionTo('registration.next-steps');
    }
  }

  async #handleRedirectPartnerApi(registration) {
    let organizationId = registration.belongsTo('organization').id();
    if (this.deviceManager.isMobile || this.deviceManager.isWebview) {
      await this.router.transitionTo('registrations.already-created', organizationId);
    } else {
      let organizations = await fetchNavigationOrganizationsClient();
      let appOrganization = organizations.find(o => o.id === organizationId);
      if (!appOrganization) return;
      window.location.href = `${jsURL}/organizations/${appOrganization.slug}`;
    }
  }
}
